module.exports = __webpack_public_path__ + "static/dating-app-cover-97caedc6a71132868b3483850305695b.png";